import { render, staticRenderFns } from "./MoleculeFeedSectionContentCardDesign2.vue?vue&type=template&id=b2d29bb8&"
import script from "./MoleculeFeedSectionContentCardDesign2.vue?vue&type=script&lang=js&"
export * from "./MoleculeFeedSectionContentCardDesign2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports